goog.provide('el8.ptdata.implantableDevices');

goog.require('el8.model.base');
goog.require('el8.ptdata.model.PatientItemSet');
goog.require('el8.appservice.notifier');

el8.ptdata.implantableDevices = (function() {

    var _class = function(spec) { this.populate(spec); };

    _class.inheritsFrom(el8_Entity);
    _class.makePatientItem();

    _class.addStringProperty('udi', true);
    _class.addStringProperty('location', true);
    _class.addDate('implantDate', true);
    _class.addStringProperty('status', true);
    _class.addStringProperty('reasonForInactive', true);
    _class.addStringProperty('deviceId', true);
    _class.addStringProperty('lotBatchId', true);
    _class.addStringProperty('serialNumber', true);
    _class.addStringProperty('distinctId', true);
    _class.addDate('expirationDate', true);
    _class.addDate('manufactureDate', true);
    _class.addBoolean('humanTissueDevice', true);
    _class.addStringProperty('humanTissueCode', true);
    _class.addStringProperty('deviceDescription', true);
    _class.addStringProperty('brandName', true);
    _class.addStringProperty('versionModel', true);
    _class.addStringProperty('companyName', true);
    _class.addStringProperty('mriSafety', true);
    _class.addBoolean('containsRubberLatex', true);
    _class.addStringProperty('procedureCpt', true);

    /**
     *  HELPER METHODS
     */
    _class.prototype.isActive = function() {
        return this.getStatus() === 'Active';
    };
    _class.prototype.setAsInactive= function() {
        this.setStatus('Inactive');
    };
    _class.prototype.setAsActive = function() {
        this.setStatus('Active');
    };

    /**
     * Entity Set
     */
    var that = new el8.ptdata.model.PatientItemSet({
        model: function(spec) { return new _class(spec); },
        urlLoad: function() { return el8.service.urls.get('implantableDevices'); },
        saveFn: function(item, successCallbackFn) {
            el8.appservice.notifier.notify('Implantable device being saved...');
            var saved = false;
            $.el8_ajax({
                url: el8.service.urls.get('implantableDevices', [item]),
                type: 'POST',
                async: false,
                data: JSON.stringify(item.asMap(true)),
                success: function(data) {
                    saved = true;
                    if (item.getId()) {
                        el8.ptdata.implantableDevices.updateItemId(item, data.item.id);
                    }
                    item.populate(data.item);
                    if (successCallbackFn) { successCallbackFn(item); }
                    el8.appservice.notifier.notify('Implantable device saved.');
                }
            });
            // Can only do this because async = false;
            return saved ? item : null;
        },
        deleteFn: function(item, successCallbackFn) {
            el8.appservice.notifier.notify('Implantable device being removed...');
            $.el8_ajax({
                url: el8.service.urls.get('implantableDevices', [item]),
                type: 'DELETE',
                success: function(data) {
                    el8.appservice.notifier.notify('Implantable device removed.');
                    if (successCallbackFn) { successCallbackFn(item); }
                }
            });
        }
    });

    return that;
})();


